import { render, staticRenderFns } from "./feed-base-form.vue?vue&type=template&id=64484fba&"
import script from "./feed-base-form.vue?vue&type=script&lang=js&"
export * from "./feed-base-form.vue?vue&type=script&lang=js&"
import style0 from "./feed-base-form.vue?vue&type=style&index=0&id=64484fba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports